import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import axios from "axios";
import swal from "sweetalert";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import Widget from "../../components/Widget/Widget";
import { API_TIMEOUT, NIRLABA_JENIS } from "../../utils/index";
import {
  filterRowsByMitraLembaga,
  getMitraQueryParams,
} from "../../utils/adminMitra";

const { SearchBar } = Search;

const JenisNirlabaList = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [idHapus, setIdHapus] = useState();
  const [modalDelete, setModalDelete] = useState(false);

  const load = () => {
    axios
      .get(NIRLABA_JENIS, {
        params: getMitraQueryParams(),
        timeout: API_TIMEOUT,
      })
      .then((res) => {
        const data = filterRowsByMitraLembaga(res.data?.data || []);
        setRows(data.map((item, i) => ({ ...item, nomor: i + 1 })));
      })
      .catch((err) => alert(err));
  };

  useEffect(() => {
    load();
  }, []);

  const hapus = () => {
    axios
      .delete(NIRLABA_JENIS + "/" + idHapus, { timeout: API_TIMEOUT })
      .then((res) => {
        if (res.data?.success === 1) {
          swal("Sukses", "Program dihapus", "success");
          setModalDelete(false);
          load();
        }
      })
      .catch((err) => alert(err));
  };

  const columns = [
    { dataField: "nomor", text: "No.", sort: true },
    { dataField: "nama_lembaga", text: "Lembaga", sort: true },
    { dataField: "bantuan", text: "Program", sort: true },
    { dataField: "sumber_dana", text: "Sumber dana" },
    { dataField: "bentuk", text: "Bentuk" },
    { dataField: "target", text: "Target" },
    {
      dataField: "id",
      text: "Aksi",
      formatter: (cell, row) => (
        <div>
          <Button
            color="info"
            size="xs"
            className="mr-2"
            onClick={() => {
              const q = new URLSearchParams({
                tahun: String(new Date().getFullYear()),
                bantuan: row.bantuan || "",
              });
              if (row.id_lembaga) q.set("id_lembaga", String(row.id_lembaga));
              dispatch(push(`/admin/nirlaba/bantuan-detail?${q.toString()}`));
            }}
          >
            Detail
          </Button>
          <Button
            color="success"
            size="xs"
            className="mr-2"
            onClick={() => dispatch(push(`/admin/nirlaba/jenis/${cell}/edit`))}
          >
            Edit
          </Button>
          <Button
            color="danger"
            size="xs"
            onClick={() => {
              setIdHapus(cell);
              setModalDelete(true);
            }}
          >
            Hapus
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-top-line">
        <h2 className="page-title">
          Jenis program <span className="fw-semi-bold">mitra</span>
        </h2>
      </div>
      <Widget>
        <ToolkitProvider keyField="id" data={rows} columns={columns} search>
          {(props) => (
            <div>
              <div className="d-flex justify-content-between mb-3">
                <SearchBar {...props.searchProps} />
                <Button
                  color="primary"
                  onClick={() => dispatch(push("/admin/nirlaba/jenis/new"))}
                >
                  Tambah program
                </Button>
              </div>
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory()}
                bootstrap4
              />
            </div>
          )}
        </ToolkitProvider>
      </Widget>
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(false)}>
        <ModalHeader>Hapus program</ModalHeader>
        <ModalBody>Yakin menghapus jenis program ini?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalDelete(false)}>
            Batal
          </Button>
          <Button color="danger" onClick={hapus}>
            Hapus
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default JenisNirlabaList;
